import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import {
  ChartListContainer,
  InfographicListContainer,
  PageLayout,
  InfographicViewContainer,
  AssetExplorerContainer,
  ThreeDViewerContainer,
} from 'containers';
import { ConnectedRouter } from 'connected-react-router';
import { history } from 'store';
import IntroductionComponent from 'components/IntroductionComponent';
import Roadmap from 'components/Roadmap';
import ChartView from 'components/ChartView';
import InfoComponent from 'components/InfoComponent';

function Routes() {
  return (
    <ConnectedRouter history={history}>
      <PageLayout>
        <Switch>
          <Route path="/" exact component={() => <Redirect to="/info" />} />
          <Route path="/assets/" exact component={AssetExplorerContainer} />
          <Route path="/assets/:id" exact component={AssetExplorerContainer} />
          <Route path="/info" exact component={InfoComponent} />
          <Route path="/charts" exact component={ChartListContainer} />
          <Route path="/charts/:chartId" exact component={ChartView} />
          <Route path="/intro" exact component={IntroductionComponent} />
          <Route path="/roadmap" exact component={Roadmap} />
          <Route path="/3d" exact component={ThreeDViewerContainer} />
          <Route
            path="/infographics"
            exact
            component={InfographicListContainer}
          />
          <Route
            path="/infographics/:id"
            exact
            component={InfographicViewContainer}
          />
        </Switch>
      </PageLayout>
    </ConnectedRouter>
  );
}

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js